module.exports = __webpack_public_path__ + "1200853164019f201f1d201e6129f1de.png";